import { mark } from './brandMarks';

export const DISPLAY = "'Roc Grotesk','Montserrat','Arial Black',sans-serif";
export const BODY = "'Sofia Pro','Nunito','Helvetica Neue',Arial,sans-serif";

export const CHANNELS = [
  { id: 'website', label: 'Website blocks', title: 'Website blocks', blurb: 'Paste-in blocks to get financing on your website.' },
  { id: 'email-signature', label: 'Email signature', title: 'Email signature', blurb: 'Two treatments — one prominent, one quiet. Both sit under your normal sign-off.' },
  { id: 'email-template', label: 'Email template', title: 'Email template', blurb: 'A full invitation email for your marketing outreach.' },
  { id: 'sms', label: 'Text messages', title: 'Text messages', blurb: 'Outreach, post-estimate and reminder. Short, simple, no pressure.' },
  { id: 'qr', label: 'QR code', title: 'QR code', blurb: 'Generated from your GoodLink, available in vector for print and raster for screens.' },
  { id: 'social', label: 'Social posts', title: 'Social posts', blurb: 'Two graphics rendered live with your details, plus captions to go with them.' },
  { id: 'print', label: 'Leave-behind flyer', title: 'Leave-behind flyer', blurb: 'A convenient one-pager with your QR code, ready for the printer.' }
];

export const STORE_KEY = 'glFinancingPlusToolkit.v1';

export function esc(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function disclosure() {
  return "Financing by GoodLeap, LLC, NMLS #30336. In California, loans made or arranged pursuant to a California Financing Law license. Subject to credit approval; not available in all states. *An initial rate check uses a soft credit inquiry only and won't affect your credit score.";
}

export function disclosureShort() {
  return "Financing by GoodLeap, LLC, NMLS #30336. In California, loans made or arranged pursuant to a California Financing Law license. Subject to credit approval; not available in all states. *An initial rate check uses a soft credit inquiry only and won't affect your credit\u00A0score.";
}

export function smsDisclaimer() {
  return "Financing by GoodLeap, LLC, NMLS #30336. In California, loans made or arranged pursuant to a California Financing Law license. Subject to credit approval; not available in all states. *An initial rate check uses a soft credit inquiry only and won't affect your credit score. Reply STOP to opt out.";
}

export function fontLink(includeFontLink = true) {
  if (includeFontLink === false) return '';
  return '<!-- GoodLeap brand fonts (Roc Grotesk, Sofia Pro) are used automatically when licensed on your site. This line loads the approved fallbacks so the block looks right everywhere else. -->\n<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700&family=Nunito:wght@400;600&display=swap">\n';
}

export function wordmark(variant, height) {
  return mark(variant, height);
}

/* Roc Grotesk wordmark as live text — for email, where inline SVG and data URIs get stripped. */
export function wordmarkText(color, size) {
  return '<span style="font-family:' + DISPLAY + ';font-weight:500;font-size:' + size + 'px;color:' + color + ';white-space:nowrap">GoodLeap</span>';
}

export function ctaButton(link, label, size) {
  const pad = size === 'small' ? '10px 22px' : '16px 32px';
  const fs = size === 'small' ? 14 : 18;
  return '<a href="' + esc(link) + '" target="_blank" rel="noopener" style="display:inline-block;background:#F7B334;color:#200F51;padding:' + pad + ';border-radius:12px;text-decoration:none;font-family:' + DISPLAY + ';font-weight:500;font-size:' + fs + 'px;line-height:1.25;text-transform:capitalize">' + label + '</a>';
}

export function schema(link) {
  return '\n  <meta itemprop="name" content="Home improvement financing by GoodLeap">\n' +
    '  <meta itemprop="description" content="Apply for home improvement financing in minutes with no impact to your credit score.">\n' +
    '  <meta itemprop="url" content="' + esc(link) + '">\n' +
    '  <div itemprop="provider" itemscope itemtype="https://schema.org/Organization" style="display:none">\n' +
    '    <meta itemprop="name" content="GoodLeap LLC"><meta itemprop="url" content="https://www.goodleap.com">\n  </div>';
}

export function schemaAttrs(includeSchema = true) {
  return includeSchema === false ? '' : ' itemscope itemtype="https://schema.org/FinancialProduct"';
}

function schemaBlock(link, includeSchema) {
  if (includeSchema === false) return '';
  return schema(link);
}

/* ---------- website blocks ---------- */
export function getBannerHTML(link, opts = {}) {
  const includeFontLink = opts.includeFontLink;
  const includeSchema = opts.includeSchema;
  return fontLink(includeFontLink) + '<!-- GoodLeap Financing+ — promo bar -->\n' +
'<div' + schemaAttrs(includeSchema) + ' style="position:relative;background:linear-gradient(93.207deg,#472BA4 -14%,#200F51 88%);padding:18px 24px 24px;font-family:' + BODY + '">' + schemaBlock(link, includeSchema) + '\n' +
'  <div style="max-width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:center;gap:24px;flex-wrap:wrap">\n' +
'    <span style="display:inline-block;transform:scale(0.9);transform-origin:center">' + ctaButton(link, 'Apply now', 'large') + '</span>\n' +
'    <p style="margin:0;color:#FFFEFC;font-size:17px;line-height:26px;text-align:center">Financing available &mdash; apply in minutes with no impact to your credit score*</p>\n' +
'    ' + wordmark('white', 28) + '\n' +
'  </div>\n' +
'  <div style="max-width:1200px;margin:8px auto 0;text-align:center"><p style="margin:0;color:#BCB6CA;font-size:12px;line-height:16px">' + esc(disclosureShort()) + '</p></div>\n' +
'</div>';
}

export function getHeroHTML(link, opts = {}) {
  const includeFontLink = opts.includeFontLink;
  const includeSchema = opts.includeSchema;
  return fontLink(includeFontLink) + '<!-- GoodLeap Financing+ — hero section -->\n' +
'<section' + schemaAttrs(includeSchema) + ' style="position:relative;background:linear-gradient(93.207deg,#472BA4 -14%,#200F51 88%);padding:96px 24px;font-family:' + BODY + '">' + schemaBlock(link, includeSchema) + '\n' +
'  <div style="position:absolute;top:36px;right:24px">' + wordmark('white', 30) + '</div>\n' +
'  <div style="max-width:900px;margin:0 auto;text-align:center">\n' +
'    <p style="margin:0 0 32px;display:inline-flex;align-items:center;gap:10px;color:#D1C1FF;font-family:' + DISPLAY + ';font-weight:500;font-size:18px;line-height:22px;letter-spacing:0.08em;text-transform:uppercase">Financing available</p>\n' +
'    <h2 style="margin:0 0 24px;font-family:' + DISPLAY + ';font-weight:500;font-size:clamp(40px,6vw,64px);line-height:1.02;color:#FFFEFC">Make your home project<br><span style="background:linear-gradient(90deg,#6C51E3,#D551C9,#FF8300);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:#F7B334">affordable</span></h2>\n' +
'    <p style="margin:0 auto 40px;max-width:620px;color:#FFFEFC;font-size:20px;line-height:28px">Apply in minutes, with no impact to your credit score.*<br>Flexible terms and monthly payments that fit your budget.</p>\n' +
'    ' + ctaButton(link, 'Apply now', 'large') + '\n' +
'    <p style="margin:32px auto 0;max-width:640px;color:#BCB6CA;font-size:12px;line-height:16px">' + esc(disclosureShort()).replace('*An initial', '<br>*An initial') + '</p>\n' +
'  </div>\n' +
'</section>';
}

export function getInfoHTML(link, name, opts = {}) {
  const includeFontLink = opts.includeFontLink;
  const step = (n, h, b) =>
'      <div style="background:#EFE8FF;border-radius:24px;padding:32px">\n' +
'        <div style="width:48px;height:48px;border-radius:50%;background:#472BA4;color:#FFFFFF;display:flex;align-items:center;justify-content:center;font-family:' + DISPLAY + ';font-weight:500;font-size:22px;margin-bottom:20px">' + n + '</div>\n' +
'        <h3 style="margin:0 0 8px;font-family:' + DISPLAY + ';font-weight:500;font-size:24px;line-height:28px;color:#200F51">' + h + '</h3>\n' +
'        <p style="margin:0;font-size:16px;line-height:24px;color:#14140F">' + b + '</p>\n' +
'      </div>';
  const faq = (q, a) =>
'      <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="padding:24px 0;border-top:0.5px solid #B1AFB2">\n' +
'        <h4 itemprop="name" style="margin:0 0 8px;font-family:' + DISPLAY + ';font-weight:500;font-size:20px;line-height:26px;color:#200F51">' + q + '</h4>\n' +
'        <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer"><p itemprop="text" style="margin:0;font-size:16px;line-height:24px;color:#555555">' + a + '</p></div>\n' +
'      </div>';
  return fontLink(includeFontLink) + '<!-- GoodLeap Financing+ — how financing works, with FAQ schema -->\n' +
'<section style="position:relative;background:#FFFEFC;padding:96px 24px;font-family:' + BODY + '">\n' +
'  <div style="position:absolute;top:32px;right:24px">' + wordmark('purple', 31) + '</div>\n' +
'  <div style="max-width:1000px;margin:0 auto">\n' +
'    <h2 style="margin:0 0 16px;font-family:' + DISPLAY + ';font-weight:500;font-size:clamp(32px,4vw,48px);line-height:1.08;color:#200F51">How GoodLeap&#8217;s financing works</h2>\n' +
'    <p style="margin:0 0 48px;max-width:640px;font-size:20px;line-height:28px;color:#14140F">Three steps, and the first one takes a few minutes.</p>\n' +
'    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:24px;margin-bottom:48px">\n' +
step(1, 'Apply', "A short application. A soft credit inquiry only, so your score isn't affected.*") + '\n' +
step(2, 'Review your options', 'Personalized offers through GoodLeap, with clear terms and monthly payments.') + '\n' +
step(3, 'Get started', 'Pick the plan that fits and we get to work on your home.') + '\n' +
'    </div>\n' +
'    <div style="margin-bottom:48px">' + ctaButton(link, 'Apply now', 'large') + '</div>\n' +
'    <div itemscope itemtype="https://schema.org/FAQPage">\n' +
'      <h3 style="margin:0 0 8px;font-family:' + DISPLAY + ';font-weight:500;font-size:32px;line-height:36px;color:#200F51">Common questions</h3>\n' +
faq('Will submitting an application affect my credit score?', 'No. The initial application uses a soft credit inquiry, which does not impact your credit score. A hard inquiry happens once your system is installed if you choose to move forward with the financing.') + '\n' +
faq('What kinds of projects qualify?', 'GoodLeap finances dozens of different home improvement projects, including most of the projects offered by ' + esc(name) + '. Visit goodleap.com to learn more.') + '\n' +
faq('How quickly will I know?', 'Most applicants get a decision within seconds. Occasionally GoodLeap will request additional documentation in order to fully approve you for financing.') + '\n' +
'    </div>\n' +
'    <p style="margin:32px 0 0;font-size:12px;line-height:16px;color:#555555">' + esc(disclosure()) + '</p>\n' +
'  </div>\n' +
'</section>';
}

export function getFooterHTML(link, opts = {}) {
  const includeFontLink = opts.includeFontLink;
  const includeSchema = opts.includeSchema;
  return fontLink(includeFontLink) + '<!-- GoodLeap Financing+ — footer CTA strip -->\n' +
'<div' + schemaAttrs(includeSchema) + ' style="position:relative;background:linear-gradient(93.207deg,#472BA4 -14%,#200F51 88%);padding:64px 24px;font-family:' + BODY + ';text-align:center">' + schemaBlock(link, includeSchema) + '\n' +
'  <div style="position:absolute;top:24px;right:24px">' + wordmark('white', 24) + '</div>\n' +
'  <p style="margin:0 0 20px;display:inline-flex;align-items:center;gap:10px;color:#D1C1FF;font-family:' + DISPLAY + ';font-weight:500;font-size:14px;line-height:18px;letter-spacing:0.08em;text-transform:uppercase">Financing available</p>\n' +
'  <h2 style="margin:0 0 32px;font-family:' + DISPLAY + ';font-weight:500;font-size:clamp(28px,3.5vw,40px);line-height:1.1;color:#FFFEFC">Ready when you are.<br><span style="background:linear-gradient(90deg,#6C51E3,#D551C9,#FF8300);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:#F7B334">Apply today.</span></h2>\n' +
'  ' + ctaButton(link, 'Get started', 'large') + '\n' +
'  <p style="margin:32px auto 0;max-width:640px;color:#BCB6CA;font-size:12px;line-height:16px">' + esc(disclosureShort()) + '</p>\n' +
'</div>';
}

/* ---------- email signature ---------- */
export function getSigBoldHTML(link) {
  return '<!-- GoodLeap Financing+ — email signature, prominent -->\n' +
'<table cellpadding="0" cellspacing="0" border="0" style="font-family:' + BODY + '">\n' +
'  <tr><td>\n' +
'    <a href="' + esc(link) + '" target="_blank" rel="noopener" style="display:block;max-width:320px;background:#200F51;border-radius:12px;padding:20px 24px;text-decoration:none">\n' +
'      <span style="display:block;font-family:' + DISPLAY + ';font-weight:500;font-size:18px;line-height:24px;color:#FFFEFC">Financing available through ' + wordmark('white', 21) + '</span>\n' +
'      <span style="display:block;margin-top:12px;font-family:' + DISPLAY + ';font-weight:500;font-size:15px;line-height:20px;color:#F7B334">Apply in minutes &rarr;</span>\n' +
'    </a>\n' +
'  </td></tr>\n' +
'  <tr><td style="padding-top:12px"><p style="margin:0;font-size:10px;line-height:14px;color:#555555;max-width:420px">' + esc(disclosureShort()) + '</p></td></tr>\n' +
'</table>';
}

export function getSigMinimalHTML(link) {
  return '<!-- GoodLeap Financing+ — email signature, minimal -->\n' +
'<table cellpadding="0" cellspacing="0" border="0" style="font-family:' + BODY + '">\n' +
'  <tr><td style="vertical-align:middle;padding-right:16px">\n' +
'    <a href="' + esc(link) + '" target="_blank" rel="noopener" style="display:inline-block;background:#F7B334;color:#200F51;padding:10px 20px;border-radius:12px;text-decoration:none;font-family:' + DISPLAY + ';font-weight:500;font-size:14px;line-height:18px">Apply now</a>\n' +
'  </td>\n' +
'  <td style="vertical-align:middle;padding-left:16px;border-left:1px solid #D5D4D4">\n' +
'    <p style="margin:0;font-size:14px;line-height:20px;color:#14140F">Financing available through ' + wordmark('purple', 16) + '</p>\n' +
'    <p style="margin:2px 0 0;font-size:13px;line-height:18px;color:#555555">Apply in minutes, no impact to your credit score.*</p>\n' +
'  </td></tr>\n' +
'  <tr><td colspan="2" style="padding-top:12px"><p style="margin:0;font-size:10px;line-height:14px;color:#555555;max-width:460px">' + esc(disclosureShort()) + '</p></td></tr>\n' +
'</table>';
}

/* ---------- email template ---------- */
export function getEmailTplHTML(link, name, opts = {}) {
  const includeFontLink = opts.includeFontLink;
  const row = (n, h, b) =>
'        <tr>\n' +
'          <td width="56" style="vertical-align:top;padding:0 16px 20px 0"><div style="width:40px;height:40px;border-radius:50%;background:#472BA4;color:#FFFFFF;text-align:center;line-height:40px;font-family:' + DISPLAY + ';font-weight:500;font-size:18px">' + n + '</div></td>\n' +
'          <td style="padding-bottom:20px"><p style="margin:0;font-family:' + DISPLAY + ';font-weight:500;font-size:18px;line-height:24px;color:#200F51">' + h + '</p><p style="margin:4px 0 0;font-size:15px;line-height:22px;color:#555555">' + b + '</p></td>\n' +
'        </tr>';
  return fontLink(includeFontLink) + '<!-- GoodLeap Financing+ — customer invitation email -->\n' +
'<div style="font-family:' + BODY + ';max-width:600px;margin:0 auto;background:#FFFFFF;border-radius:24px;overflow:hidden">\n' +
'  <div style="position:relative;background:linear-gradient(93.207deg,#472BA4 -14%,#200F51 88%);padding:48px 32px 40px;text-align:center">\n' +
'    <div style="position:absolute;top:20px;right:24px">' + wordmark('white', 22) + '</div>\n' +
'    <p style="margin:0 0 16px;font-family:' + DISPLAY + ';font-weight:500;font-size:13px;line-height:18px;letter-spacing:0.08em;text-transform:uppercase;color:#D1C1FF">Financing available</p>\n' +
'    <h1 style="margin:0;font-family:' + DISPLAY + ';font-weight:500;font-size:32px;line-height:36px;color:#FFFEFC">Your home project,<br><span style="background:linear-gradient(90deg,#6C51E3,#D551C9,#FF8300);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:#F7B334">made affordable</span></h1>\n' +
'  </div>\n' +
'  <div style="padding:40px 32px">\n' +
'    <p style="margin:0 0 16px;font-size:17px;line-height:26px;color:#14140F">Hi [First name],</p>\n' +
'    <p style="margin:0 0 16px;font-size:17px;line-height:26px;color:#14140F">Financing is available for your project with ' + esc(name) + '. Applying takes a few minutes and won\'t affect your credit score.*</p>\n' +
'    <p style="margin:0 0 28px;font-size:17px;line-height:26px;color:#14140F">Here is how it works:</p>\n' +
'    <table cellpadding="0" cellspacing="0" border="0" width="100%">\n' +
row(1, 'Apply', 'A short application. A soft credit inquiry only, so your score isn\'t affected.*') + '\n' +
row(2, 'Review your options', 'Personalized offers through GoodLeap, with clear terms and monthly payments.') + '\n' +
row(3, 'Get started', 'Pick the plan that fits and we get to work on your home.') + '\n' +
'    </table>\n' +
'    <div style="text-align:center;margin:12px 0 28px">' + ctaButton(link, 'Apply now', 'large') + '</div>\n' +
'    <p style="margin:16px 0 0;font-family:' + DISPLAY + ';font-weight:500;font-size:16px;line-height:22px;color:#200F51">The ' + esc(name) + ' team</p>\n' +
'    <p style="margin:24px 0 0;padding-top:20px;border-top:0.5px solid #B1AFB2;font-size:11px;line-height:16px;color:#555555">' + esc(disclosure()) + '</p>\n' +
'  </div>\n' +
'</div>';
}

/* ---------- sms ---------- */
export function smsBodies(link) {
  return [
    { title: 'Outreach', body: 'Hi [First name] — financing is available for your project through GoodLeap. Applying takes a few minutes and won\'t affect your credit score.* ' + link },
    { title: 'After the estimate', body: 'Hi [First name], thanks for having us out. If you would like to move forward, financing through GoodLeap is available here: ' + link },
    { title: 'Reminder', body: 'Hi [First name], your estimate is still open. Financing through GoodLeap takes a few minutes to apply for, with no impact to your credit score.* ' + link }
  ];
}

/* ---------- social ---------- */
export function wrapText(ctx, text, maxWidth) {
  const words = String(text).split(' ');
  const lines = [];
  let line = '';
  for (const w of words) {
    const test = line ? line + ' ' + w : w;
    if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = w; }
    else line = test;
  }
  if (line) lines.push(line);
  return lines;
}

export function captionTexts(link) {
  return [
    'A new roof, a heat pump, panels on the roof — the project is rarely the hard part. Paying for it is. Financing through GoodLeap takes a few minutes to apply for, with no impact to your credit score.* ' + link,
    'Getting an estimate from us this week? Ask about financing. Terms and monthly payments are spelled out before you commit, and applying won\'t affect your credit score.* ' + link,
    'We finance the work through GoodLeap: apply in minutes, see your options, and pick the plan that fits your budget. Start here: ' + link
  ];
}

/* ---------- print ---------- */
export function printHTML({ appliedName, appliedLink, qrSvg }) {
  const name = esc(appliedName);
  const link = esc(appliedLink);
  const qr = qrSvg || '';
  return '<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + name + ' — financing available</title>' +
'<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700&family=Nunito:wght@400;600&display=swap">' +
'<style>@page{size:letter;margin:0}html,body{margin:0;padding:0}' +
'body{width:8.5in;height:11in;overflow:hidden;font-family:' + BODY + ';color:#14140F;-webkit-print-color-adjust:exact;print-color-adjust:exact}' +
'.top{background:linear-gradient(93.207deg,#472BA4 -14%,#200F51 88%);color:#FFFEFC;padding:0.55in 0.75in 0.5in;position:relative}' +
'.top .logo{position:absolute;top:0.4in;right:0.75in}' +
'.eyebrow{font-family:' + DISPLAY + ';font-weight:500;font-size:11pt;letter-spacing:0.08em;text-transform:uppercase;color:#D1C1FF;margin:0 0 18pt}' +
'h1{font-family:' + DISPLAY + ';font-weight:500;font-size:34pt;line-height:1.04;margin:0}' +
'h1 span{background:linear-gradient(90deg,#6C51E3,#D551C9,#FF8300);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:#F7B334}' +
'.lede{font-size:13pt;line-height:1.45;margin:12pt 0 0;max-width:5.6in}' +
'.body{padding:0.3in 0.75in 0.1in}' +
'.body h2{font-family:' + DISPLAY + ';font-weight:500;font-size:14pt;line-height:1.15;margin:0 0 0.12in;color:#200F51}' +
'.steps{display:flex;gap:0.2in;margin:0 0 0.22in}' +
'.step{flex:1;background:#EFE8FF;border-radius:14pt;padding:11pt}' +
'.step .n{font-family:' + DISPLAY + ';font-weight:500;font-size:15pt;color:#472BA4;margin:0 0 4pt}' +
'.step h3{font-family:' + DISPLAY + ';font-weight:500;font-size:11pt;line-height:1.2;margin:0 0 4pt;color:#200F51}' +
'.step p{font-size:8.5pt;line-height:1.35;margin:0;color:#14140F}' +
'.scan{display:flex;gap:0.32in;align-items:center;border-top:0.5pt solid #B1AFB2;padding-top:0.27in}' +
'.scan .qr{width:1.62in;height:1.62in;flex:0 0 auto}' +
'.scan .qr svg{display:block;width:100%;height:100%}' +
'.scan h2{font-family:' + DISPLAY + ';font-weight:500;font-size:20pt;line-height:1.08;margin:0 0 8pt;color:#F7B334}' +
'.scan p{font-size:11pt;line-height:1.5;margin:0;color:#14140F}' +
'.url{font-family:' + DISPLAY + ';font-weight:500;font-size:12pt;color:#472BA4;margin-top:10pt;word-break:break-all}' +
'.faq{margin:0 0 0.24in;padding-top:0.2in;border-top:0.5pt solid #B1AFB2}' +
'.faq h2{font-family:' + DISPLAY + ';font-weight:500;font-size:14pt;margin:0 0 8pt;color:#200F51}' +
'.faq .q{margin-bottom:7pt}' +
'.faq .q p{margin:0;font-size:9pt;line-height:1.35}' +
'.faq .q .a{font-weight:500;color:#200F51;margin-bottom:1pt}' +
'.faq .q .b{color:#555555}' +
'.legal{font-size:7.5pt;line-height:1.4;color:#555555;margin:0.04in 0.75in 0}' +
'.foot{display:flex;align-items:center;justify-content:space-between;gap:0.3in;margin:0.16in 0.75in 0;padding-top:0.13in;border-top:0.5pt solid #B1AFB2}' +
'.foot .co{font-family:' + DISPLAY + ';font-weight:500;font-size:13pt;color:#200F51}' +
'</style></head><body>' +
'<div class="top"><div class="logo">' + wordmark('white', 22) + '</div><p class="eyebrow">Financing available</p>' +
'<h1>Make your home project<br><span>affordable</span></h1>' +
'<p class="lede">Applying takes a few minutes and won\'t affect your credit score.*<br>See your terms and monthly payment before you commit to anything.</p></div>' +
'<div class="body"><h2>How GoodLeap&#8217;s financing works</h2><div class="steps">' +
'<div class="step"><p class="n">1</p><h3>Apply</h3><p>A short application. A soft credit inquiry only, so your score isn\'t affected.*</p></div>' +
'<div class="step"><p class="n">2</p><h3>Review your options</h3><p>Personalized offers with terms and monthly payments spelled out.</p></div>' +
'<div class="step"><p class="n">3</p><h3>Get started</h3><p>Pick the plan that fits and we get to work on your home.</p></div>' +
'</div>' +
'<div class="faq"><h2>Common questions</h2>' +
'<div class="q"><p class="a">Will submitting an application affect my credit score?</p><p class="b">No. The initial application uses a soft credit inquiry, which does not impact your credit score.</p></div>' +
'<div class="q"><p class="a">What kinds of projects qualify?</p><p class="b">GoodLeap finances dozens of different home improvement projects, including most of the projects offered by ' + name + '.</p></div>' +
'<div class="q"><p class="a">How quickly will I know?</p><p class="b">Most applicants get a decision within seconds. Occasionally GoodLeap will request additional documentation in order to fully approve you for financing.</p></div>' +
'</div>' +
'<div class="scan"><div class="qr">' + qr + '</div><div><h2>Scan to apply</h2>' +
'<p>Point your phone camera at the code. It opens the application for your project with ' + name + '.</p>' +
'<p class="url">' + link + '</p></div></div></div>' +
'<p class="legal">' + esc(disclosure()) + '</p>' +
'<div class="foot"><span class="co">' + name + '</span></div>' +
'</body></html>';
}

export function guidesFor(channel) {
  const g = [];
  const mk = (key, label, title, steps, tip) => ({ key, label, title, steps, tip });
  if (channel === 'website') {
    g.push(mk('site', 'Where this code goes', 'Where to paste the code', [
      'WordPress — a Custom HTML block in the page editor, or a footer widget.',
      'Wix — add an Embed HTML element and paste the code into it.',
      'Squarespace — insert a Code block and paste the code.',
      'Weebly — use the Embed Code element.',
      'A hand-built site — paste it straight into the .html file.'
    ], 'Not sure? Send the block to whoever maintains your site, or ask your GoodLeap representative.'));
  }
  if (channel === 'email-signature') {
    g.push(mk('gmail', 'Add it in Gmail', 'Adding it in Gmail', [
      'Open Gmail, click the gear icon, then See all settings.',
      'On the General tab, scroll to Signature and pick or create your signature.',
      'Copy the HTML here, then paste it into the signature box — Gmail keeps the styling.',
      'Scroll down and click Save changes.'
    ], 'Paste it under your name and title, not above them.'));
    g.push(mk('outlook', 'Add it in Outlook', 'Adding it in Outlook', [
      'Open Outlook and go to File, Options, Mail, Signatures.',
      'Click New, name the signature, then click OK.',
      'Copy the HTML here and paste it into the signature editor.',
      'Assign it to new messages and replies, then click OK.'
    ], 'Outlook strips embedded images, so this block uses live text — nothing to break.'));
    g.push(mk('yahoo', 'Add it in Yahoo', 'Adding it in Yahoo Mail', [
      'Sign in to Yahoo Mail on the web.',
      'Click the gear/Settings icon (top right) and select "More settings."',
      'Go to "Writing email" in the left sidebar.',
      'Under "Signature," toggle it on.',
      'Type or paste your signature in the text box (you can format text, add links, or insert an image/logo using the toolbar).',
      'If you have multiple Yahoo email accounts, select which account this signature applies to from the dropdown.',
      'Changes save automatically — close the settings panel when done.'
    ], 'Yahoo Mail doesn\'t currently support setting different signatures for new emails vs. replies/forwards — it\'s one signature applied everywhere.'));
  }
  if (channel === 'sms') {
    g.push(mk('manual', 'Send it by hand', 'Sending it yourself', [
      'Open your messaging app and start a message to the homeowner.',
      'Paste the template and replace [First name].',
      'Check that the link opens before you send it to a list.'
    ], 'Send only to homeowners who have agreed to hear from you.'));
    g.push(mk('jobber', 'Send it from Jobber', 'Saving it as a Jobber template', [
      'Log in to Jobber and open Settings.',
      'Go to Client communications, or Message templates.',
      'Click New template, name it Financing+, paste the message and save.',
      'From a job or quote, choose Send message and pick the template.',
      'Optional: add the link to your quote and invoice templates so every notification carries it.'
    ], 'Merge tags fill in the name automatically — leave [First name] out when you use them.'));
  }
  return g;
}

export function normalizeGoodLink(link) {
  let next = String(link || '').trim();
  if (next && !/^https?:\/\//i.test(next)) next = 'https://' + next;
  return next;
}

export function isDemoSavedData(saved) {
  if (!saved) return false;
  return /acme/i.test(saved.name || '') || /acme/i.test(saved.link || '') || /your-link/i.test(saved.link || '');
}
